import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
} from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../../../../Utils/responsive";
import "../../../../../src/App.scss";
import IntroPanel from "../../../../Components/Layout/Default/intro-panel";

const actualWidth = Dimensions.get("screen").width;

const set1 = (props, isDisable) => {
  return (
    <>
      <IntroPanel
        buttonColor="la"
        header="GREAT"
        buttonText="OK"
        buttonDisabled={isDisable}
        onButtonPress={() => {
          props.setDisable(true);
          props.fun();
        }}
      >
        <div>
          {props.isVariantC
            ? "Now let's see how you feel when the chances of gaining and losing are changed."
            : "Now let's see how you feel when the amounts you stand to gain or lose are changed."}
        </div>
        {props.isVariantC && (
          <div>
            In the following scenarios the chances of a{`\n`}
            gain are higher than that of a loss.
          </div>
        )}
      </IntroPanel>
    </>
  );
};
const set2 = (props, isDisable) => {
  return (
    <>
      <IntroPanel
        buttonColor="la"
        header="GREAT"
        buttonText="OK"
        buttonDisabled={isDisable}
        onButtonPress={() => {
          props.setDisable(true);
          props.fun();
        }}
      >
        Now what about when the odds{`\n`}
        change?
      </IntroPanel>
    </>
  );
};
const set3 = (props, isDisable) => {
  return (
    <>
      <IntroPanel
        buttonColor="la"
        header="FINALLY"
        buttonText="OK"
        buttonDisabled={isDisable}
        onButtonPress={() => {
          props.setDisable(true);
          props.fun();
        }}
      >
        We're going to change things{`\n`}
        more.
      </IntroPanel>
    </>
  );
};

const Index = (props) => {
  const [disable, setDisable] = useState(true);

  setTimeout(() => {
    setDisable(false);
  }, 1000);

  return (
    <View style={styles.content}>
      {props.currentSet === 0 ? (
        <>
          <IntroPanel
            buttonColor="la"
            header="LOSS & GAIN"
            buttonText="OK"
            buttonDisabled={disable}
            onButtonPress={() => {
              props.showDescriptionPage();
              props.fun();
              setDisable(true);
            }}
          >
            Investing is all about accepting a degree of risk for the potential
            of a larger return.{`\n`}
            {`\n`}This exercise measures when the tradeoff between gains and
            losses feels right and when it feels wrong.{`\n`}
          </IntroPanel>
        </>
      ) : props.currentSet === 1 ? (
        set1(props, disable)
      ) : props.currentSet === 2 ? (
        set2(props, disable)
      ) : (
        props.currentSet === 3 && set3(props, disable)
      )}
    </View>
  );
};

export default Index;
export const styles = StyleSheet.create({
  content: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    height: "99vh",
    width: "100vw",
    marginBottom: "15vh",
  },
});
